module.exports = __webpack_public_path__ + "static/img/qq_1.76ec79bc.png";